/**
 * Session invalidation: API layer notifies when auth fails so the app can
 * clear state and send the user to login (no "Unauthorized" stuck on portal pages).
 */

export const PORTAL_SESSION_STORAGE_KEYS = [
  'otp_expected_code',
  'otp_email',
  'otp_name',
];

export function clearPortalSessionStorage() {
  for (const k of PORTAL_SESSION_STORAGE_KEYS) {
    try {
      sessionStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  }
}

let handler = null;

export function setSessionInvalidationHandler(fn) {
  handler = typeof fn === 'function' ? fn : null;
}

export function clearSessionInvalidationHandler() {
  handler = null;
}

/**
 * @param {{ message?: string, status?: number }} detail
 */
export function notifySessionInvalid(detail) {
  if (!handler) return;
  try {
    handler(detail || {});
  } catch (e) {
    console.warn('[sessionInvalidation] handler failed', e?.message || e);
  }
}
